/* @flow */
import type { Action } from "../action";
import type { Account } from "../CommonTypes";

export type AugmentedAccount = Account & {
  estimatedBalance: string
};

type State = Array<AugmentedAccount>;

function receiveSocketMessage(state, payload) {
  if (payload.op === "operationClosed" || payload.op === "operationOpened") {
    const accountType = payload.real === 1 ? "real" : "demo";
    const account = state.find(a => a.type === accountType);

    if (account == null) {
      return state;
    }

    const nextBalance = payload.op === "operationClosed"
      ? payload.balance.toFixed(2)
      : payload.balance;

    const nextAccount = {
      ...account,
      balance: nextBalance,
      estimatedBalance: nextBalance
    };

    return [...state.filter(a => a !== account), nextAccount];
  } else if (payload.op === "deposit-bonus-inserted") {
    // Мы же не даём бонусы демо аккаунтам? Было бы странно
    const account = state.find(a => a.type === "real");

    if (account == null) {
      return state;
    }

    const nextBalance = (parseFloat(account.balance) + payload.amount).toFixed(
      2
    );

    const nextAccount = {
      ...account,
      balance: nextBalance,
      estimatedBalance: nextBalance
    };

    return [...state.filter(a => a !== account), nextAccount];

  }

  return state;
}

function requestDealOpening(state, payload) {
  if (payload.accountType) {
    const account = state.find(a => a.type === payload.accountType);

    if (account == null) {
      return state;
    }

    const estimatedBalance = parseFloat(account.estimatedBalance);

    const nextEstimatedBalance = estimatedBalance - payload.amount;

    const nextAccount = {
      ...account,
      estimatedBalance: nextEstimatedBalance.toFixed(2)
    };

    return [...state.filter(a => a !== account), nextAccount];
  }

  return state;
}

function accounts(state: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_ACCOUNTS":
      return action.payload.map(account => ({
        ...account,
        estimatedBalance: account.balance
      }));
    case "RECEIVE_SOCKET_MESSAGE":
      return receiveSocketMessage(state, action.payload);
    case "REQUEST_DEAL_OPENING":
      return requestDealOpening(state, action.payload);
    default:
      return state;
  }
}

export default accounts;



// WEBPACK FOOTER //
// ./src/redux/reducer/accounts.js